module.exports = __webpack_public_path__ + "img/shitu.c3740fcb.jpg";